function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsNoWhiteResidueBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "320px",
    height: "320px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.897
    },
    fill: "#1D439A",
    d: "M 141.5,2.5 C 207.81,-2.09405 258.977,23.2393 295,78.5C 317.251,117.93 322.584,159.596 311,203.5C 290.483,264.685 248.65,301.852 185.5,315C 116.229,322.939 62.3957,298.106 24,240.5C 1.74912,201.07 -3.58422,159.404 8,115.5C 29.9261,50.9802 74.4261,13.3135 141.5,2.5 Z M 142.5,12.5 C 167.689,10.2651 192.023,13.7651 215.5,23C 223.136,25.8329 230.136,29.6663 236.5,34.5C 203.844,74.8012 172.011,114.135 141,152.5C 139.419,149.447 137.086,148.78 134,150.5C 132.959,153.636 133.793,156.136 136.5,158C 133,162.167 129.5,166.333 126,170.5C 124.135,168.327 121.969,167.993 119.5,169.5C 117.948,172.567 118.615,175.067 121.5,177C 116.977,182.52 112.144,187.687 107,192.5C 106,194.5 105,196.5 104,198.5C 87.0613,219.391 69.8947,240.058 52.5,260.5C 13.9248,217.144 3.0915,167.478 20,111.5C 42.1611,55.3429 82.9944,22.3429 142.5,12.5 Z M 167.5,136.5 C 192.103,105.324 217.269,73.991 243,42.5C 244.133,40.7888 245.633,40.2888 247.5,41C 300.741,85.0846 317.908,140.585 299,207.5C 277.068,263.73 236.235,296.563 176.5,306C 132.178,310.391 93.511,297.891 60.5,268.5C 72.4855,253.184 84.8188,238.184 97.5,223.5C 103.02,225.922 105.186,224.256 104,218.5C 103.25,217.874 102.416,217.374 101.5,217C 108,209.167 114.5,201.333 121,193.5C 123.075,195.648 125.408,195.982 128,194.5C 128.839,191.86 128.339,189.527 126.5,187.5C 129.55,181.117 134.217,176.45 140.5,173.5C 142.726,164.786 147.893,158.786 156,155.5C 156.72,153.888 156.554,152.388 155.5,151C 158.667,147.167 161.833,143.333 165,139.5C 166.238,144.637 168.905,145.637 173,142.5C 173.833,138.164 172,136.164 167.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.715
    },
    fill: "#1D439A",
    d: "M 100.5,51.5 C 106.488,51.664 107.821,54.164 104.5,59C 98.4034,59.1475 97.0701,56.6475 100.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.81
    },
    fill: "#1D439A",
    d: "M 113.5,59.5 C 119.158,58.6794 120.825,60.846 118.5,66C 112.741,67.1387 111.074,64.972 113.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.772
    },
    fill: "#1D439A",
    d: "M 128.5,66.5 C 133.328,67.6411 134.328,70.1411 131.5,74C 127,74.8333 125.167,73 126,68.5C 126.995,67.9341 127.828,67.2674 128.5,66.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.783
    },
    fill: "#1D439A",
    d: "M 88.5,74.5 C 94.3173,74.0295 95.984,76.1962 93.5,81C 87.741,82.1387 86.0744,79.972 88.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.733
    },
    fill: "#1D439A",
    d: "M 141.5,74.5 C 145.979,74.8975 147.312,77.2309 145.5,81.5C 142.167,83.1667 140.167,82.1667 139.5,78.5C 139.803,76.8857 140.47,75.5523 141.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.755
    },
    fill: "#1D439A",
    d: "M 102.5,80.5 C 107.914,79.5646 109.914,81.5646 108.5,86.5C 102.486,88.4643 100.486,86.4643 102.5,80.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.752
    },
    fill: "#1D439A",
    d: "M 154.5,82.5 C 159.486,82.3049 161.152,84.4716 159.5,89C 152.561,90.5741 150.894,88.4074 154.5,82.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.808
    },
    fill: "#1D439A",
    d: "M 117.5,86.5 C 123.158,85.6794 124.825,87.846 122.5,93C 116.741,94.1387 115.074,91.972 117.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.789
    },
    fill: "#1D439A",
    d: "M 167.5,90.5 C 173.158,89.6794 174.825,91.846 172.5,97C 166.741,98.1387 165.074,95.972 167.5,90.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.748
    },
    fill: "#1D439A",
    d: "M 131.5,92.5 C 136.006,91.5272 138.172,93.1939 138,97.5C 131.645,101.201 129.478,99.5342 131.5,92.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.796
    },
    fill: "#1D439A",
    d: "M 80.5,98.5 C 86.1581,97.6794 87.8248,99.846 85.5,105C 79.5077,105.811 77.841,103.644 80.5,98.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.77
    },
    fill: "#1D439A",
    d: "M 145.5,98.5 C 151.359,97.0737 153.359,99.0737 151.5,104.5C 145.82,106.154 143.82,104.154 145.5,98.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.754
    },
    fill: "#1D439A",
    d: "M 95.5,102.5 C 101.158,101.679 102.825,103.846 100.5,109C 94.2435,109.934 92.5769,107.767 95.5,102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.792
    },
    fill: "#1D439A",
    d: "M 160.5,104.5 C 166.158,103.679 167.825,105.846 165.5,111C 159.741,112.139 158.074,109.972 160.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.772
    },
    fill: "#1D439A",
    d: "M 194.5,105.5 C 199.675,104.507 201.509,106.507 200,111.5C 198,114.167 196,114.167 194,111.5C 193.322,109.402 193.489,107.402 194.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.769
    },
    fill: "#1D439A",
    d: "M 110.5,106.5 C 115.675,105.507 117.509,107.507 116,112.5C 112.913,114.87 110.413,114.203 108.5,110.5C 109.18,109.14 109.847,107.807 110.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.717
    },
    fill: "#1D439A",
    d: "M 125.5,110.5 C 131.488,110.664 132.821,113.164 129.5,118C 123.834,117.835 122.501,115.335 125.5,110.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.754
    },
    fill: "#1D439A",
    d: "M 207.5,113.5 C 213.359,112.074 215.359,114.074 213.5,119.5C 207.82,121.154 205.82,119.154 207.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.711
    },
    fill: "#1D439A",
    d: "M 140.5,114.5 C 146.488,114.664 147.821,117.164 144.5,122C 138.886,121.944 137.553,119.444 140.5,114.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.755
    },
    fill: "#1D439A",
    d: "M 188.5,116.5 C 194.113,115.079 196.28,117.079 195,122.5C 189.101,124.433 186.935,122.433 188.5,116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.725
    },
    fill: "#1D439A",
    d: "M 156.5,118.5 C 161.68,119.404 162.68,121.904 159.5,126C 152.934,125.805 151.934,123.305 156.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.729
    },
    fill: "#1D439A",
    d: "M 222.5,120.5 C 226.805,120.842 228.305,123.176 227,127.5C 225.795,128.071 224.628,128.738 223.5,129.5C 224.982,133.215 223.649,135.381 219.5,136C 222.462,139.488 221.795,142.155 217.5,144C 220.265,146.966 219.932,149.633 216.5,152C 219.1,154.459 219.1,156.959 216.5,159.5C 217.738,163.506 218.738,167.506 219.5,171.5C 219.43,172.772 219.097,173.938 218.5,175C 221.423,177.103 222.09,179.769 220.5,183C 226.707,185.454 226.874,187.954 221,190.5C 219.893,190.415 218.893,190.081 218,189.5C 217.257,187.559 217.424,185.726 218.5,184C 214.179,182.205 213.512,179.539 216.5,176C 212.046,174.414 211.379,171.747 214.5,168C 212.148,167.424 211.148,165.924 211.5,163.5C 211.79,161.956 212.456,160.623 213.5,159.5C 211.655,157.464 211.155,155.13 212,152.5C 212.75,151.874 213.584,151.374 214.5,151C 210.632,148.002 210.965,145.336 215.5,143C 212.363,138.905 213.363,136.238 218.5,135C 215.582,131.835 216.082,129.335 220,127.5C 220.153,124.849 220.987,122.516 222.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.791
    },
    fill: "#1D439A",
    d: "M 205.5,121.5 C 209.396,122.78 210.396,125.28 208.5,129C 203.333,130.5 201.5,128.667 203,123.5C 203.995,122.934 204.828,122.267 205.5,121.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.67
    },
    fill: "#1D439A",
    d: "M 75.5,122.5 C 81.4877,122.664 82.821,125.164 79.5,130C 73.4034,130.147 72.0701,127.647 75.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.75
    },
    fill: "#1D439A",
    d: "M 91.5,124.5 C 96.2664,125.158 97.5997,127.658 95.5,132C 91.8721,133.316 89.5388,132.149 88.5,128.5C 89.1716,126.84 90.1716,125.507 91.5,124.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.781
    },
    fill: "#1D439A",
    d: "M 105.5,127.5 C 111.158,126.679 112.825,128.846 110.5,134C 104.741,135.139 103.074,132.972 105.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.777
    },
    fill: "#1D439A",
    d: "M 185.5,127.5 C 190.698,127.081 192.365,129.248 190.5,134C 184.013,135.158 182.347,132.991 185.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.791
    },
    fill: "#1D439A",
    d: "M 235.5,128.5 C 238.864,127.873 240.864,129.206 241.5,132.5C 237.78,139.003 235.113,146.003 233.5,153.5C 234.953,155.644 234.62,157.477 232.5,159C 233.574,159.739 234.241,160.739 234.5,162C 234.362,164.862 234.362,167.695 234.5,170.5C 236.061,173.583 237.394,176.749 238.5,180C 237.723,184.642 235.556,185.475 232,182.5C 231.566,179.498 230.399,176.831 228.5,174.5C 227.823,171.815 227.823,168.982 228.5,166C 227.196,165.196 226.529,164.029 226.5,162.5C 226.245,157.547 226.745,152.547 228,147.5C 228.5,147 229,146.5 229.5,146C 227.972,143.119 228.638,140.786 231.5,139C 231.043,138.586 230.709,138.086 230.5,137.5C 232.449,134.597 234.116,131.597 235.5,128.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.707
    },
    fill: "#1D439A",
    d: "M 121.5,129.5 C 127.488,129.664 128.821,132.164 125.5,137C 119.403,137.147 118.07,134.647 121.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.754
    },
    fill: "#1D439A",
    d: "M 137.5,131.5 C 142.266,132.158 143.6,134.658 141.5,139C 137.798,140.393 135.798,139.226 135.5,135.5C 135.803,133.886 136.47,132.552 137.5,131.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.731
    },
    fill: "#1D439A",
    d: "M 200.5,131.5 C 205,131.164 206.833,133.164 206,137.5C 202.414,140.3 199.914,139.467 198.5,135C 198.978,133.697 199.645,132.531 200.5,131.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.848
    },
    fill: "#1D439A",
    d: "M 248.5,136.5 C 250.199,136.34 251.866,136.506 253.5,137C 254.081,137.893 254.415,138.893 254.5,140C 248.802,150.661 248.135,161.661 252.5,173C 251.658,177.612 249.491,178.446 246,175.5C 240.733,162.098 241.567,149.098 248.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.756
    },
    fill: "#1D439A",
    d: "M 183.5,138.5 C 188.262,139.092 189.596,141.592 187.5,146C 181.202,146.495 179.868,143.995 183.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.751
    },
    fill: "#1D439A",
    d: "M 197.5,141.5 C 202.709,140.705 204.709,142.705 203.5,147.5C 197.129,149.796 195.129,147.796 197.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.726
    },
    fill: "#1D439A",
    d: "M 73.5,147.5 C 74.9305,147.421 76.2638,147.754 77.5,148.5C 79.8896,154.608 78.0563,156.608 72,154.5C 71.185,151.802 71.685,149.468 73.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.746
    },
    fill: "#1D439A",
    d: "M 87.5,148.5 C 92.9136,147.565 94.9136,149.565 93.5,154.5C 87.4863,156.464 85.4863,154.464 87.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.767
    },
    fill: "#1D439A",
    d: "M 104.5,148.5 C 109.378,148.535 110.711,150.868 108.5,155.5C 105.167,157.167 103.167,156.167 102.5,152.5C 102.803,150.886 103.47,149.552 104.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8
    },
    fill: "#1D439A",
    d: "M 118.5,149.5 C 124.359,148.074 126.359,150.074 124.5,155.5C 118.82,157.154 116.82,155.154 118.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.739
    },
    fill: "#1D439A",
    d: "M 165.5,150.5 C 170.675,149.672 172.675,151.672 171.5,156.5C 165.129,158.796 163.129,156.796 165.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.723
    },
    fill: "#1D439A",
    d: "M 182.5,150.5 C 187.668,151.339 188.668,153.839 185.5,158C 182.186,159.165 180.186,157.998 179.5,154.5C 180.172,152.84 181.172,151.507 182.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.736
    },
    fill: "#1D439A",
    d: "M 196.5,151.5 C 201.006,150.527 203.172,152.194 203,156.5C 196.645,160.201 194.478,158.534 196.5,151.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.74
    },
    fill: "#1D439A",
    d: "M 196.5,161.5 C 201.709,160.705 203.709,162.705 202.5,167.5C 196.153,169.82 194.153,167.82 196.5,161.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.75
    },
    fill: "#1D439A",
    d: "M 182.5,162.5 C 186.979,162.898 188.312,165.231 186.5,169.5C 183.167,171.167 181.167,170.167 180.5,166.5C 180.803,164.886 181.47,163.552 182.5,162.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.749
    },
    fill: "#1D439A",
    d: "M 165.5,164.5 C 170.914,163.565 172.914,165.565 171.5,170.5C 165.486,172.464 163.486,170.464 165.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.755
    },
    fill: "#1D439A",
    d: "M 151.5,165.5 C 155.979,165.898 157.312,168.231 155.5,172.5C 152.167,174.167 150.167,173.167 149.5,169.5C 149.803,167.886 150.47,166.552 151.5,165.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.748
    },
    fill: "#1D439A",
    d: "M 103.5,170.5 C 109.359,169.074 111.359,171.074 109.5,176.5C 103.82,178.154 101.82,176.154 103.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.733
    },
    fill: "#1D439A",
    d: "M 89.5,171.5 C 94.378,171.535 95.7113,173.868 93.5,178.5C 89.9509,180.131 87.9509,178.964 87.5,175C 87.8618,173.566 88.5285,172.399 89.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8
    },
    fill: "#1D439A",
    d: "M 198.5,171.5 C 204.158,170.679 205.825,172.846 203.5,178C 197.741,179.139 196.074,176.972 198.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.736
    },
    fill: "#1D439A",
    d: "M 75.5,172.5 C 80.6103,174.923 80.777,177.59 76,180.5C 70.2348,178.265 70.0681,175.598 75.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.73
    },
    fill: "#1D439A",
    d: "M 183.5,174.5 C 189.488,174.664 190.821,177.164 187.5,182C 181.834,181.835 180.501,179.335 183.5,174.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.735
    },
    fill: "#1D439A",
    d: "M 169.5,177.5 C 174.68,178.404 175.68,180.904 172.5,185C 168,185.833 166.167,184 167,179.5C 167.995,178.934 168.828,178.267 169.5,177.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.685
    },
    fill: "#1D439A",
    d: "M 202.5,180.5 C 207.68,181.404 208.68,183.904 205.5,188C 201,188.833 199.167,187 200,182.5C 200.995,181.934 201.828,181.267 202.5,180.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.749
    },
    fill: "#1D439A",
    d: "M 152.5,181.5 C 157.709,180.705 159.709,182.705 158.5,187.5C 152.129,189.796 150.129,187.796 152.5,181.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.716
    },
    fill: "#1D439A",
    d: "M 138.5,184.5 C 143.378,184.535 144.711,186.868 142.5,191.5C 138.951,193.131 136.951,191.964 136.5,188C 136.862,186.566 137.528,185.399 138.5,184.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.828
    },
    fill: "#1D439A",
    d: "M 186.5,186.5 C 192.158,185.679 193.825,187.846 191.5,193C 185.741,194.139 184.074,191.972 186.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.778
    },
    fill: "#1D439A",
    d: "M 204.5,190.5 C 209.006,189.527 211.172,191.194 211,195.5C 204.645,199.201 202.478,197.534 204.5,190.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.791
    },
    fill: "#1D439A",
    d: "M 171.5,191.5 C 177.158,190.679 178.825,192.846 176.5,198C 170.741,199.139 169.074,196.972 171.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.687
    },
    fill: "#1D439A",
    d: "M 92.5,194.5 C 98.4877,194.664 99.821,197.164 96.5,202C 90.4034,202.147 89.0701,199.647 92.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.699
    },
    fill: "#1D439A",
    d: "M 157.5,196.5 C 162,196.164 163.833,198.164 163,202.5C 160.667,205.167 158.333,205.167 156,202.5C 155.252,200.16 155.752,198.16 157.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.727
    },
    fill: "#1D439A",
    d: "M 78.5,197.5 C 83.3284,198.641 84.3284,201.141 81.5,205C 77,205.833 75.1667,204 76,199.5C 76.9947,198.934 77.828,198.267 78.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.754
    },
    fill: "#1D439A",
    d: "M 190.5,197.5 C 195.006,196.527 197.172,198.194 197,202.5C 190.645,206.201 188.478,204.534 190.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.754
    },
    fill: "#1D439A",
    d: "M 142.5,201.5 C 148.362,201.662 149.695,204.162 146.5,209C 145.101,209.595 143.768,209.428 142.5,208.5C 141.286,206.141 141.286,203.808 142.5,201.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.742
    },
    fill: "#1D439A",
    d: "M 176.5,204.5 C 178.604,204.201 180.604,204.534 182.5,205.5C 183.659,210.666 181.659,212.333 176.5,210.5C 175.181,208.468 175.181,206.468 176.5,204.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.755
    },
    fill: "#1D439A",
    d: "M 128.5,206.5 C 129.93,206.421 131.264,206.754 132.5,207.5C 134.708,214.133 132.875,215.8 127,212.5C 126.252,210.16 126.752,208.16 128.5,206.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.752
    },
    fill: "#1D439A",
    d: "M 164.5,210.5 C 169.68,211.404 170.68,213.904 167.5,218C 163,218.833 161.167,217 162,212.5C 162.995,211.934 163.828,211.267 164.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.704
    },
    fill: "#1D439A",
    d: "M 114.5,211.5 C 119.68,212.404 120.68,214.904 117.5,219C 113,219.833 111.167,218 112,213.5C 112.995,212.934 113.828,212.267 114.5,211.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.738
    },
    fill: "#1D439A",
    d: "M 150.5,217.5 C 155.68,218.404 156.68,220.904 153.5,225C 149,225.833 147.167,224 148,219.5C 148.995,218.934 149.828,218.267 150.5,217.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.706
    },
    fill: "#1D439A",
    d: "M 136.5,224.5 C 141.668,225.339 142.668,227.839 139.5,232C 132.934,231.805 131.934,229.305 136.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.706
    },
    fill: "#1D439A",
    d: "M 121.5,231.5 C 127.488,231.664 128.821,234.164 125.5,239C 119.886,238.944 118.553,236.444 121.5,231.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.775
    },
    fill: "#1D439A",
    d: "M 107.5,238.5 C 113.488,238.664 114.821,241.164 111.5,246C 105.834,245.835 104.501,243.335 107.5,238.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.742
    },
    fill: "#1D439A",
    d: "M 93.5,245.5 C 99.3619,245.662 100.695,248.162 97.5,253C 96.1011,253.595 94.7678,253.428 93.5,252.5C 92.2857,250.141 92.2857,247.808 93.5,245.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsNoWhiteResidueBlue);
export default __webpack_public_path__ + "static/media/icons_noWhiteResidue_blue.0a249dd0b0dcb7732e817ac5250dfd0d.svg";
export { ForwardRef as ReactComponent };